
document.addEventListener("DOMContentLoaded", () => {

  const fileInput = document.getElementById('file-input');
  const fileNameDisplay = document.querySelector('.file-name');
  const fileInputLabel = document.querySelector('.file-label');
  const deleteButton = document.getElementById('delete-btn');

  if (fileInput != null) {
    fileInput.addEventListener('change', function(event) {
        if (event.target.files.length > 0) {
            const fileName = event.target.files[0].name;
            fileNameDisplay.childNodes[0].textContent = fileName; // Set the file name text
            fileNameDisplay.classList.add("active")
            fileInputLabel.classList.add("hide")
        } else {
            fileNameDisplay.childNodes[0].textContent = ''; // Reset when no file is selected
            fileNameDisplay.classList.remove("active")
            fileInputLabel.classList.remove("hide")
        }
    });

    deleteButton.addEventListener('click', function(event) {
        event.preventDefault(); // Prevent any default action from occurring

        fileInput.value = ''; // Clear the file input
        fileNameDisplay.childNodes[0].textContent = ''; // Reset filename display
        fileNameDisplay.classList.remove("active")
        fileInputLabel.classList.remove("hide")
    });

    }

  const textareas = document.querySelectorAll('textarea');



  const adjustHeight = (textarea) => {
      // Сбросить высоту перед расчётом
      textarea.style.height = 'auto';
  
      const computedStyle = window.getComputedStyle(textarea);
      const lineHeight = parseInt(computedStyle.lineHeight, 10);
      const minHeight = lineHeight; // Минимальная высота равная одной строке
      textarea.style.height = minHeight + 'px'; // Устанавливаем минимальную высоту
  
      if (textarea.scrollHeight > minHeight) {
          textarea.style.height = textarea.scrollHeight + 'px'; // Устанавливаем высоту по содержимому, если оно превышает одну строку
      }
  };
  
  textareas.forEach(textarea => {
      textarea.addEventListener('input', function() {
          adjustHeight(this);
      });
      textarea.addEventListener('change', function() {
          adjustHeight(this);
      });
  
      adjustHeight(textarea);
  });

  


})